<template>
  <el-dialog
    :visible.sync="payoutModalShow"
    width="30%"
    @closed="$emit('close')"
    v-loading="loading"
  >
    <div class="row" slot="title">
      <div class="col-12">
        <h4 class="m-0">Payout</h4>
        <small class="text-light-gold" v-if="closeout_business">{{
          closeout_business.name
        }}</small>
      </div>
    </div>
    <div class="row">
      <div class="col-12" v-if="closeouts.length == 0">
        <div class="row" v-if="animals_sold">
          <div class="col-12 font-weight-bold label-field">
            Sale Date <span class="required-flag">*</span>
          </div>
          <div class="col-12 mb-2">
            <el-date-picker
              v-model="closeoutForm.sale_date"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              type="date"
              class="w-100"
              placeholder="Pick a settlement date"
            ></el-date-picker>
          </div>
          <div class="col-12 font-weight-bold label-field">Buyers Name</div>
          <div class="col-12 mb-2">
            <el-input v-model="closeoutForm.buyers_name" />
          </div>
          <div class="col-12 font-weight-bold label-field">Average Weight</div>
          <div class="col-12 mb-2">
            <currency-input
              v-model="closeoutForm.average_weight"
              class="w-100"
              :precision="4"
              :currency="null"
            />
          </div>
          <div class="col-12 font-weight-bold label-field">
            End Market <span class="required-flag">*</span>
          </div>
          <div class="col-12 mb-2">
            <el-select
              class="w-100"
              v-model="closeoutForm.end_market_id"
              placeholder="Select Market"
            >
              <el-option
                v-for="item in endMarkets"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 font-weight-bold label-field">
            Settlement Date <span class="required-flag">*</span>
          </div>
          <div class="col-12 mb-2">
            <el-date-picker
              v-model="closeoutForm.settlement_date"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              type="date"
              class="w-100"
              placeholder="Pick a settlement date"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="font-weight-bold label-field">Sales Invoice</div>
            <div class="mb-2">
              <el-upload
                action
                ref="sale_invoice"
                :file-list="invoiceFile"
                :multiple="false"
                :on-change="handleUploadSaleInvoice"
                :auto-upload="false"
                :on-remove="handleRemoveSale"
              >
                <el-button size="small" type="primary">Select file</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="font-weight-bold label-field">Additional documents</div>
            <div class="">
              <el-upload
                action
                ref="sale_invoice"
                :file-list="additionalFiles"
                :multiple="true"
                :limit="3"
                :auto-upload="false"
                :on-exceed="handleExceed"
                :on-change="handleUpload"
                :on-remove="handleRemove"
              >
                <el-button size="small" type="primary">Select files</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div
          class="d-flex align-items-center justify-content-between w-100 mt-3"
        >
          <el-button class="btn-secondary" @click="$emit('close')"
            >Cancel</el-button
          >
          <el-button class="btn-primary" @click="onSubmit">Send</el-button>
        </div>
      </div>
      <div class="col-12" v-else-if="show_closeouts">
        <closeout-purchase-list
          :closeouts="closeouts"
          @close="$emit('close')"
        ></closeout-purchase-list>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import EndMarket from "../frontend/modelsPortal/EndMarket";
import CloseoutPurchase from "../frontend/modelsPortal/common/CloseoutPurchase.js";
import CloseoutPurchaseList from "./CloseoutPurchaseList.vue";
export default {
  components: { CloseoutPurchaseList },
  props: {
    closeout_purchases: {
      type: Array,
    },
    closeout_business: {
      type: Object,
    },
    closeout_livestock_class_id: {
      type: Number,
    },
    animals_sold: {
      type: Boolean,
    },
    show_closeouts: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    off_pic: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    nlis_payout_data: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      payoutModalShow: true,
      loading: false,
      closeoutForm: {
        settlement_date: null,
        sale_date: null,
        buyers_name: null,
        average_weight: null,
        end_market_id: null,
        type_id: 2, //payout
        business_id: this.closeout_business.id,
        livestock_class_id: this.closeout_livestock_class_id,
        animals_sold: this.animals_sold,
      },
      additionalFiles: [],
      invoiceFile: [],
      endMarkets: [],
      closeouts: [],
    };
  },
  computed: {
    pickerOptionsSaleDate() {
      return {
        disabledDate(time) {
          return true; //time.getTime() <= Date.now();
        },
      };
    },
    pickerOptions() {
      let self = this;
      return {
        disabledDate(time) {
          let min = null;
          if (self.closeout_purchases.length > 0) {
            let invoiceDueDates = self.closeout_purchases.map(
              ({ invoice_due_date }) => invoice_due_date
            );
            min = invoiceDueDates.reduce(function (a, b) {
              return a < b ? a : b;
            });
          }

          return (
            moment(time.getTime()).isBefore(
              moment(Date.now()).format("YYYY-MM-DD")
            ) ||
            [0, 6].includes(time.getDay()) ||
            (min && time.getTime() > moment(min))
          );
        },
      };
    },
  },
  mounted() {
    this.getEndMarkets();
    this.setDefaultDates();
  },
  methods: {
    setDefaultDates() {
      if (!this.nlis_payout_data || this.nlis_payout_data.length == 0) return;

      let transferDates = this.nlis_payout_data.map(
        ({ transfer_to_at }) => transfer_to_at
      );
      const unique = [...new Set(transferDates)];

      if (unique.length == 1 && unique[0]) {
        this.closeoutForm.sale_date = unique[0];
        let settlement_date = moment(this.closeoutForm.sale_date).add(
          14,
          "days"
        );
        if (moment(settlement_date).isAfter(moment())) {
          this.closeoutForm.settlement_date = settlement_date;
        }
      }
    },
    maxSettlementDate() {
      let invoiceDueDates = this.closeout_purchases.map(
        ({ invoice_due_date }) => invoice_due_date
      );
      let min = invoiceDueDates.reduce(function (a, b) {
        return a < b ? a : b;
      });
      return min;
    },
    handleUploadSaleInvoice(file) {
      this.invoiceFile = [file];
    },
    handleRemoveSale(file) {
      this.invoiceFile = [];
    },
    handleExceed(files, fileList) {
      this.$message.warning(`You can upload 3 files`);
    },
    handleUpload(file) {
      console.log(this.additionalFiles);
      this.additionalFiles.push(file);
    },
    handleRemove(file) {
      this.additionalFiles.splice(file, 1);
    },
    getEndMarkets() {
      new EndMarket()
        .where("is_active", true)
        .whereIn("id", [2, 4])
        .get()
        .then((result) => {
          this.endMarkets = result;
        })
        .catch((err) => {});
    },
    onSubmit() {
      this.loading = true;

      let closeout_purchase_ids = this.closeout_purchases.map(({ id }) => id);
      this.closeoutForm.purchase_ids = closeout_purchase_ids;

      if (this.nlis_payout_data && this.nlis_payout_data.length > 0) {
        let closeout_group_ids = this.nlis_payout_data.map(
          ({ group_id }) => group_id
        );
        this.closeoutForm.group_ids = closeout_group_ids;
      }

      if (this.invoiceFile.length > 0)
        this.closeoutForm.sale_invoice = this.invoiceFile[0].raw;

      let additionalFiles = [];
      if (this.additionalFiles.length > 0) {
        this.additionalFiles.forEach((file) => {
          additionalFiles.push(file.raw);
        });
      }
      this.closeoutForm.additional_files = additionalFiles;

      new CloseoutPurchase(this.closeoutForm)
        .save()
        .then((res) => {
          let closeouts = Object.values(res);
          this.closeouts = closeouts;
          this.$message.success(`Closeout request sent`);
          this.$emit("refresh");
          if (!this.show_closeouts) {
            this.$emit("close");
          }
        })
        .catch((errors) => {
          this.loading = false;
          var errorText = "";
          _.forEach(errors.response.data.errors, function (value) {
            errorText += "" + value + " ";
          });
          this.$message({
            type: "error",
            message: errorText,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
